/*
 * Inicializa carrosséis Splide vanilla em [data-splide] — substitui o
 * @splidejs/react-splide. As opções vêm do atributo (JSON), como nos
 * componentes originais (PDP mobile e página de senha).
 */
function mountAll() {
  if (!window.Splide) {
    // splide.min.js carrega com defer; tenta de novo quando terminar.
    window.addEventListener('load', mountAll, {once: true});
    return;
  }
  document.querySelectorAll('[data-splide]').forEach((el) => {
    if (el.dataset.splideMounted) return;
    let options = {};
    try {
      options = JSON.parse(el.dataset.splide || '{}');
    } catch (error) {
      options = {};
    }
    const splide = new window.Splide(el, options).mount();
    el.dataset.splideMounted = 'true';

    // Pausa vídeos fora do slide ativo, toca o vídeo do slide ativo.
    const pauseInactiveVideos = () => {
      const slides = splide.Components.Elements.slides;
      slides.forEach((slide, index) => {
        const video = slide.querySelector('video');
        if (!video) return;
        if (index === splide.index) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    };

    splide.on('mounted moved', pauseInactiveVideos);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountAll);
} else {
  mountAll();
}